<template>
  <el-dialog
    title="人员安排"
    :visible.sync="dialogVisible"
    :close-on-click-modal=false
    :close-on-press-escape=false
    width="500px"
    @close="handleClose"
  >
    <ul class="arrange-header">
      <li>
        <span class="label">T3机构： </span>
        <span class="value">{{ detailList[0].organ }}</span>
      </li>
      <li>
        <span class="label">T4机构： </span>
        <span class="value">{{ detailList[0].area }} </span>
      </li>
      <li>
        <span class="label"> 姓名： </span>
        <span class="value">{{ accountNames }}</span>
      </li>
    </ul>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="80px">
      <!-- 招募安排 -->
      <el-form-item label="招募安排" prop="step">
        <el-select v-model="form.step" placeholder="请选择">
          <el-option
            v-for="(ite,idx) in stepList"
            :key="idx"
            :label="ite.label"
            :value="ite.value"
            />
        </el-select>
      </el-form-item>
      <template v-if="!(form.step == '6')">
        <el-form-item label="面试官" prop="interviewerType">
          <el-select v-model="form.interviewerType" placeholder="请选择" @change="getReferrerlist">
            <el-option
              v-for="(ite,idx) in interviewerList"
              :key="idx"
              :label="ite.label"
              :value="ite.value"
              />
          </el-select>
        </el-form-item>
        <el-form-item prop="agentCode">
          <el-radio-group v-model="form.agentCode" size="small">
            <el-radio
              border
              v-for="(ite,idx) in agentList"
              :key="idx"
              :label="ite.leaderId"
            >{{ite.leaderName + ite.leaderId}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
     

      <div class="btns">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
      
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import { Options } from '@/components/utils/fixOptions'
//  interviewerType_status
export default {
  data() {
    return {
      dialogVisible: true, // 控制对话框的显示与隐藏
      form: {
        step: "",
        interviewerType: "",
        agentCode: "",
      },
      stepList: Options.step_status,
      interviewerList: Options.interviewerType_status,
      agentList: [],
      accountNames: "",
      rules: {
        step:[
          { required: true, message: '请选择安排阶段', trigger: 'change' }
        ],
        interviewerType:[
          { required: true, message: '请选择面试官角色', trigger: 'change' }
        ],
        agentCode:[
          { required: true, message: '请选择对应的面试官', trigger: 'change' }
        ]
      }
    };
  },
  props: {
    detailList: {
      type: Array,
      default: []
    },
  },
  mounted() {
    this.accountNames = this.detailList.map(item => item.accountName).join('、');
    console.log(this.detailList,  this.accountNames,'================')

  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 你可以在这里处理提交逻辑
          const userIds =  this.detailList.map(item => item.userId)
          const { orgCode, teamCode, branchcode } = this.detailList[0]
          const { step, agentCode } = this.form
          let agentName
          if (step != '6') {
            agentName = this.agentList.find(ite=>ite.leaderId == agentCode).leaderName
          }
        
          const data = {
            userIds: userIds,
            // accountId: '',
            interviewNode: step, //面试节点
            interviewer: {
              agentCode: agentCode,
              agentName: agentName,
              orgCode: orgCode,
              branchcode: branchcode,
              teamCode: teamCode,
            }
          }
          this.save(data)
        } else {
          //this.$message.error("表单验证失败");
          return false;
        }
      });
    },
    save(data){
      api.post(url.arrangeInterview, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose('refresh');
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: 'error',
              message: res.result.errors[0].error
            });
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        }
      });
    },
    getReferrerlist(val) {
      if (this.form.step != '2' && val == '1') {
        this.$message({
          type: 'error',
          message: "只有一面才可选择推荐人主管"
        });
        this.form.interviewerType = "";
        return;
      }
      const { reference, orgCode, areaCode } = this.detailList[0]
      const referrerCode = reference.split("-")[0]
      
      api.post(url.getInterviewers, {interviewerType: val, referrerCode: referrerCode,orgCode: orgCode,areaCode: areaCode}, (res) => {
        if (res.result.isSuccess) {
          console.log(res.data,'getReferrerlist===============')
          this.agentList = res.data
          if (this.form.interviewerType == '1' 
              && this.agentList && this.agentList.length > 0) {
            this.form.agentCode = this.agentList[0].leaderId
          }
        } else {
          this.$message({
            type: 'error',
            message: res.result.error
          }); 
        }
      });
    },
    handleClose(flag='') {
      this.form = {
        rejectionType: "一面",
        rejectionReason: [],
        customReason: "",
      };
      this.$emit("close")
      flag == 'refresh' && this.$emit("refresh")
    },
  },
};
</script>
    
<style lang="scss" scoped>

.btns {
  text-align: center;
}
.el-radio {
  margin-right: 10px !important;
}
.arrange-header {
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    padding: 10px 0;
    .label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/arrangeDialog.vue